import React from 'react';
import HexMap from '../../Carte';

const GameMapView = ({
    mockData,
    isTalking,
    mapInteraction,
    isTargetingMode,
    setIsTargetingMode,
    setSelectedTarget,
    addLog
}) => {
    return (
        <div className={`flex-1 bg-gradient-to-br from-slate-900/50 to-slate-800/50 rounded-2xl border border-blue-500/20 backdrop-blur-xl relative shadow-2xl overflow-hidden ${isTargetingMode ? 'ring-4 ring-red-500/50 animate-pulse-red' : ''}`}>
            {/* Vignette & Effects */}
            <div className="absolute inset-0 z-10 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_40%,rgba(0,0,0,0.6))] overflow-hidden" />

            {isTargetingMode && (
                <div className="absolute top-6 left-1/2 -translate-x-1/2 z-[40] bg-red-600/90 text-white px-6 py-2 rounded-full font-bold uppercase tracking-widest animate-bounce shadow-lg ring-2 ring-white">
                    SÉLECTIONNEZ UNE CIBLE
                </div>
            )}

            {mapInteraction === 'fixed' && (
                <div className="absolute inset-0 z-20 pointer-events-none opacity-10 bg-[url('https://media.giphy.com/media/o0vwzuFwCGAFO/giphy.gif')] bg-cover mix-blend-screen overflow-hidden" />
            )}

            {/* The HexMap */}
            <div className={`w-full h-full bg-gradient-to-br from-slate-800 via-blue-500 to-blue-800 shadow-2xl border border-slate-700 transform transition-transform duration-700 ease-out overflow-hidden ${isTalking ? 'scale-[1.01]' : 'scale-100'} ${mapInteraction === 'bugged' ? 'opacity-50 grayscale blur-sm' : ''} ${isTargetingMode ? 'targeting-mode' : ''}`}>
                <HexMap
                    countries_dict={mockData.countries}
                    ocean={[]}
                    gridData={mockData.grid}
                    onOpenPopin={(data) => {
                        if (isTargetingMode) {
                            const countryName = data.countryShortName;
                            const countryId = mockData.countries[countryName]?.id;
                            const cell = mockData.grid.find(c => c.country === countryId);
                            const x = cell?.x || 0;
                            const y = cell?.y || 0;

                            addLog(`%c[NUKE]%c MISSILE Lancé sur ${countryName} (x:${x}, y:${y})`, "color: #ef4444; font-weight: bold; font-size: 1.1em", "color: #fff");
                            setSelectedTarget(countryName);
                            setIsTargetingMode(false);

                            setTimeout(() => {
                                addLog(`%c[REPORT]%c Impact confirmé. Cible neutralisée. Rayon d'action : 500km.`, "color: #22c55e; font-weight: bold", "color: #aaa");
                            }, 2000);
                        }
                    }}
                />
            </div>

            {/* Overlay Stats */}
            <div className="absolute bottom-6 left-6 flex gap-4 pointer-events-none z-30">
                <div className="bg-black/40 backdrop-blur-md border border-blue-500/20 rounded-lg px-4 py-2">
                    <span className="text-blue-400 text-xs font-bold uppercase tracking-wider block">Population</span>
                    <span className="text-white text-lg font-mono">8.2M</span>
                </div>
                <div className="bg-black/40 backdrop-blur-md border border-blue-500/20 rounded-lg px-4 py-2">
                    <span className="text-blue-400 text-xs font-bold uppercase tracking-wider block">PIB</span>
                    <span className="text-white text-lg font-mono">420Md$</span>
                </div>
            </div>
        </div>
    );
};

export default GameMapView;
